import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, FreeMode, Navigation } from "swiper/modules";
import { getProductCartQty } from "../productList/utils";
import { Modal } from "react-bootstrap";
import ProductVariationChooser from "../productDetail/ProductVariationChooser";
import Rating from "../productList/sub-components/ProductRating";
import Image from "../image/Image";
import { decodeText } from "../../../utils/richText";

function ProductModal(props) {
    const { product } = props;
    const { currency } = props;
    const { discountedprice } = props;
    const { finalproductprice } = props;
    const { finaldiscountedprice } = props;

    const defaultVariation = product.variation && product.variation["0"];

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [selectedProductColor, setSelectedProductColor] = useState(defaultVariation ? defaultVariation.color : "");
    const [selectedProductSize, setSelectedProductSize] = useState(
        defaultVariation && defaultVariation.size && defaultVariation.size["@nodes"]
            ? defaultVariation.size[defaultVariation.size["@nodes"][0]].name
            : "",
    );
    const [productStock, setProductStock] = useState(
        defaultVariation && defaultVariation.size && defaultVariation.size["@nodes"]
            ? defaultVariation.size[defaultVariation.size["@nodes"][0]].stock
            : product.stock || 0,
    );
    const [quantityCount, setQuantityCount] = useState(1);

    const wishlistItem = props.wishlistitem;
    const compareItem = props.compareitem;

    const addToCart = props.addtocart;
    const addToWishlist = props.addtowishlist;
    const addToCompare = props.addtocompare;

    const cartItems = props.cartitems;

    const productCartQty = getProductCartQty(cartItems, product, selectedProductColor, selectedProductSize);

    return (
        <Fragment>
            <Modal show={props.show} onHide={props.onHide} className="product-quickview-modal-wrapper">
                <Modal.Header closeButton></Modal.Header>

                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-5 col-sm-12 col-xs-12">
                            <div className="product-large-image-wrapper">
                                <Swiper
                                    modules={[Thumbs]}
                                    thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                                    spaceBetween={10}
                                    loop={true}
                                    className="swiper-wrapper"
                                >
                                    {product.image.length > 0 &&
                                        product.image.map((single, key) => {
                                            return (
                                                <SwiperSlide key={key}>
                                                    <div className="single-image">
                                                        <Image imageNode={single} className="img-fluid" />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                </Swiper>
                            </div>
                            <div className="product-small-image-wrapper mt-15">
                                <Swiper
                                    onSwiper={setThumbsSwiper}
                                    modules={[Thumbs, FreeMode, Navigation]}
                                    spaceBetween={10}
                                    slidesPerView={4}
                                    touchRatio={0.2}
                                    freeMode={true}
                                    loop={true}
                                    slideToClickedSlide={true}
                                    navigation={{
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    }}
                                    className="swiper-wrapper"
                                >
                                    {product.image.length > 0 &&
                                        product.image.map((single, key) => {
                                            return (
                                                <SwiperSlide key={key}>
                                                    <div className="single-image">
                                                        <Image imageNode={single} className="img-fluid" />
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                </Swiper>
                                <button className="swiper-button-prev ht-swiper-button-nav">
                                    <i className="pe-7s-angle-left" />
                                </button>
                                <button className="swiper-button-next ht-swiper-button-nav">
                                    <i className="pe-7s-angle-right" />
                                </button>
                            </div>
                        </div>
                        <div className="col-md-7 col-sm-12 col-xs-12">
                            <div className="product-details-content quickview-content">
                                <h2>{decodeText(product.displayName)}</h2>
                                <div className="product-details-price">
                                    {discountedprice !== null ? (
                                        <Fragment>
                                            <span>{currency.currencySymbol + finaldiscountedprice}</span>{" "}
                                            <span className="old">{currency.currencySymbol + finalproductprice}</span>
                                        </Fragment>
                                    ) : (
                                        <span>{currency.currencySymbol + finalproductprice} </span>
                                    )}
                                </div>
                                {product.rating && product.rating > 0 ? (
                                    <div className="pro-details-rating-wrap">
                                        <div className="pro-details-rating">
                                            <Rating ratingValue={product.rating} />
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                                <div className="pro-details-list">
                                    <p>{decodeText(product.shortDescription)}</p>
                                </div>

                                {product.variation && (
                                    <ProductVariationChooser
                                        variation={product.variation}
                                        selectedProductColor={selectedProductColor}
                                        selectedProductSize={selectedProductSize}
                                        setSelectedProductColor={setSelectedProductColor}
                                        setSelectedProductSize={setSelectedProductSize}
                                        setProductStock={setProductStock}
                                        setQuantityCount={setQuantityCount}
                                    />
                                )}

                                {product.affiliateLink ? (
                                    <div className="pro-details-quality">
                                        <div className="pro-details-cart btn-hover">
                                            <a href={product.affiliateLink} rel="noopener noreferrer" target="_blank">
                                                Buy Now
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="pro-details-quality">
                                        <div className="cart-plus-minus">
                                            <button
                                                onClick={() => setQuantityCount(quantityCount > 1 ? quantityCount - 1 : 1)}
                                                className="dec qtybutton"
                                            >
                                                -
                                            </button>
                                            <input className="cart-plus-minus-box" type="text" value={quantityCount} readOnly />
                                            <button
                                                onClick={() =>
                                                    setQuantityCount(
                                                        quantityCount < productStock - productCartQty ? quantityCount + 1 : quantityCount,
                                                    )
                                                }
                                                className="inc qtybutton"
                                            >
                                                +
                                            </button>
                                        </div>
                                        <div className="pro-details-cart btn-hover">
                                            {productStock && productStock > 0 ? (
                                                <button
                                                    onClick={() =>
                                                        addToCart(product, quantityCount, selectedProductColor, selectedProductSize)
                                                    }
                                                    disabled={productCartQty > 0}
                                                    title={productCartQty > 0 ? "Added to cart" : "Add to cart"}
                                                >
                                                    {productCartQty > 0 ? "Added" : "Add To Cart"}
                                                </button>
                                            ) : (
                                                <button disabled>Out of Stock</button>
                                            )}
                                        </div>
                                        <div className="pro-details-wishlist">
                                            <button
                                                className={wishlistItem !== undefined ? "active" : ""}
                                                disabled={wishlistItem !== undefined}
                                                title={wishlistItem !== undefined ? "Added to wishlist" : "Add to wishlist"}
                                                onClick={() => addToWishlist(product)}
                                            >
                                                <i className="pe-7s-like" />
                                            </button>
                                        </div>
                                        <div className="pro-details-compare">
                                            <button
                                                className={compareItem !== undefined ? "active" : ""}
                                                disabled={compareItem !== undefined}
                                                title={compareItem !== undefined ? "Added to compare" : "Add to compare"}
                                                onClick={() => addToCompare(product)}
                                            >
                                                <i className="pe-7s-shuffle" />
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
}

ProductModal.propTypes = {
    addtocart: PropTypes.func,
    addtocompare: PropTypes.func,
    addtowishlist: PropTypes.func,
    cartitems: PropTypes.array,
    compareitem: PropTypes.object,
    currency: PropTypes.object,
    discountedprice: PropTypes.number,
    finaldiscountedprice: PropTypes.number,
    finalproductprice: PropTypes.number,
    onHide: PropTypes.func,
    product: PropTypes.object,
    show: PropTypes.bool,
    wishlistitem: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {
        cartitems: state.cartData,
    };
};

export default connect(mapStateToProps)(ProductModal);
